// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { useEffect, useState } from 'react';

/**
 * Custom React hook to track the visibility state of the page.
 * 
 * This hook listens for the 'visibilitychange' event on the document
 * and updates the visibility state accordingly. It returns a boolean
 * indicating whether the page is currently visible or not.
 *
 * @returns {boolean} - True if the page is visible, false otherwise.
 */

function usePageVisibility() {
    const [isVisible, setIsVisible] = useState(!document.hidden);

    const handleVisibilityChange = () => {
        setIsVisible(!document.hidden);
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return isVisible;
}

export default usePageVisibility;
